//证书管理-查看
<template>
  <div class="CertificateManagementRead">
    <div id="printMe">
      <div class="bag-img" ref="printContent">
        <div class="text">
          <p>
            <span>{{ content }}</span>
            <br />
            <span>{{ time }}</span>
          </p>
        </div>
      </div>
      <div class="but">
        <el-row>
          <el-button @click="downloadImg">下载</el-button>
          <el-button @click="toImg">打印</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/CertificateManagement/api'
import html2canvas from 'html2canvas'
import printJS from 'print-js'
export default {
  components: {},
  data() {
    return {
      content: '',
      time: '',
      pageObj: {
        examsUserCertId: '',
      },
      img: '',
      printObj: {
        id: 'printMe',
        popTitle: '证书信息',
        extraCss: 'https://www.google.com,https://www.google.com',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
    }
  },
  computed: {},
  watch: {},
  methods: {
    toImg() {
      // 转图片打印
      html2canvas(this.$refs.printContent, {
        scale: 2,
      }).then((canvas) => {
        const url = canvas.toDataURL()
        this.img = url
        printJS({
          printable: url,
          type: 'image',
          documentTitle: '证书信息',
        })
      })
    },
    downloadImg() {
      html2canvas(this.$refs.printContent).then((res) => {
        const url = res.toDataURL()
        const a = document.createElement('a')
        a.href = url
        a.download = 'image'
        a.click()
      })
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const examsUserCertId = this.$route.query.examsUserCertId
    api.getCertContent({ examsUserCertId }).then((data) => {
      const certContent = data.data.split('号')
      this.content = certContent[0] + '号'
      this.time = certContent[1]
      console.log(data.data.split('号'))
    })
  },
  mounted() {},
}
</script>
<style lang='scss' scoped>
.CertificateManagementRead {
  margin: 0 auto;
  width: 600px;
  padding-top: 30px;
  background-color: #fff;
}
.CertificateManagementRead .bag-img {
  background: url('../../assets/bag-image.jpg');
  background-size: 600px 235px;
  width: 600px;
  height: 235px;
  padding: 17px 0;
  background-repeat: no-repeat;
  box-shadow: 0 4px 20px 0 rgba(26, 50, 110, 0.32);
}
.text {
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 400px;
  color: #656565;
  font-size: 14px;
}
span {
  color: #7d7d7d;
  font-family: Arial, Verdana, Helvetica, sans-serif;
  font-size: 12px;
}
.but {
  width: 600px;
  padding-top: 25px;
  display: flex;
  justify-content: center;
}
</style>